import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/takeUntil';
import { OffboardingReturnPermissions } from '../../models/offboarding.model';
import { OffboardingService } from '../../services/offboarding.service';
import { OffboardingReturnModalComponent } from './offboarding-return-modal.component';
import { RETURN_MODE } from './offboarding-return.gateway';
import { ASSET } from '../common/employee-assets/asset.constants';
import { assetErrorKey } from '../common/employee-assets/asset.helpers';

@Component({selector: 'app-offboarding-returns', template: `
  <section class="offboard-returns" [class.offboard-returns-profile]="profileActions" *ngIf="errorKey || !permissionOnly && permissions && (permissions.canReturnClothing || permissions.canReturnAssets)">
    <h2 *ngIf="profileActions">{{ 'offboarding.return.title' | translate }}</h2>
    <div class="offboard-actions">
    <button *ngIf="!permissionOnly && permissions && permissions.canReturnClothing" class="btn btn-secondary" type="button" [disabled]="loading" (click)="open(modes.clothing)">{{ 'offboarding.return.clothing' | translate }}</button>
    <button *ngIf="!permissionOnly && permissions && permissions.canReturnAssets" class="btn btn-secondary" type="button" [disabled]="loading" (click)="open(modes.assets)">{{ 'offboarding.return.assets' | translate }}</button>
    <span *ngIf="errorKey" role="alert">{{ errorKey | translate }} <button class="btn btn-link" type="button" (click)="load()">{{ 'ASSET_RETRY' | translate }}</button></span>
    </div>
  </section>`, styleUrls: ['./offboarding-sequential.component.css', './offboarding-returns.component.css']})
export class OffboardingReturnsComponent implements OnChanges, OnDestroy {
  @Input() employeeId: string;
  @Input() permissionOnly = false;
  @Input() profileActions = false;
  @Output() changed = new EventEmitter<void>();
  permissions: OffboardingReturnPermissions = null;
  loading = false;
  modes = RETURN_MODE;
  errorKey = ASSET.empty;
  private request: Subscription;
  private dialog: NgbModalRef;
  private disposed = false;
  private destroyed = new Subject<void>();
  constructor(private api: OffboardingService, private modals: NgbModal, private changeDetectorRef?: ChangeDetectorRef) {}
  ngOnChanges(): void {
    this.closeDialog();
    if (this.request) { this.request.unsubscribe(); }
    this.permissions = null; this.loading = false; this.errorKey = ASSET.empty;
    if (this.employeeId) { this.load(); }
  }
  ngOnDestroy(): void { this.disposed = true; this.closeDialog(); this.destroyed.next(); this.destroyed.complete(); }
  load(): void {
    if (this.disposed) { return; }
    if (this.request) { this.request.unsubscribe(); }
    this.loading = true; this.errorKey = ASSET.empty;
    const employee = this.employeeId;
    this.request = this.api.returnPermissions(employee).takeUntil(this.destroyed).subscribe(result => {
      if (this.disposed || this.employeeId !== employee) { return; }
      this.permissions = result; this.loading = false; this.mark();
    }, error => {
      if (this.disposed || this.employeeId !== employee) { return; }
      this.permissions = null; this.loading = false;
      this.errorKey = error && error.status === ASSET.forbidden ? ASSET.empty : assetErrorKey(error, false); this.mark();
    });
  }
  open(mode: string): void {
    if (this.disposed || this.loading || this.dialog || !this.permissions || !(mode === RETURN_MODE.assets ? this.permissions.canReturnAssets : this.permissions.canReturnClothing)) { return; }
    const ref = this.modals.open(OffboardingReturnModalComponent, {size: ASSET.modalSize, beforeDismiss: () => !ref.componentInstance.busy});
    const content: OffboardingReturnModalComponent = ref.componentInstance;
    content.employeeId = this.employeeId; content.mode = mode;
    this.dialog = ref;
    ref.result.then(() => this.returned(ref), () => this.cancelled(ref, content));
  }
  private returned(ref: NgbModalRef): void { if (this.dialog !== ref) { return; } this.dialog = null; if (!this.disposed) { this.load(); this.changed.emit(); } }
  private cancelled(ref: NgbModalRef, content: OffboardingReturnModalComponent): void {
    if (this.dialog !== ref) { return; }
    if (content.refreshRequired) { this.returned(ref); } else { this.dialog = null; }
  }
  private closeDialog(): void { if (this.dialog) { const ref = this.dialog; this.dialog = null; ref.close(); } }
  private mark(): void { if (this.changeDetectorRef) { this.changeDetectorRef.markForCheck(); } }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/offboarding/offboarding-returns.component.ts